// extracted by mini-css-extract-plugin
export default {"row":"ServiceComponent_row__yJ1Aj","title_box":"ServiceComponent_title_box__VuCt7","img_box":"ServiceComponent_img_box__cbtEQ","logo":"ServiceComponent_logo__GD1Vd"};